/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";

// style rules
import { Animation, Typography } from "../../styles";

const FeaturedFoodCard = ({ toggleSidePanel, foodItem, isSidePanelOff }) => {
	return (
		<AnimatePresence>
			<Card
				initial={"initial"}
				animate={"animate"}
				exit={"initial"}
				variants={Animation.cards.opacityVariants}
				onClick={!isSidePanelOff ? (() => toggleSidePanel(foodItem)) : undefined}
				issidepaneloff={isSidePanelOff ? "true" : "false"}
			>
				<div className="top-part">
					<AspectRatioBox>
						<img loading="lazy" src={foodItem.image} alt={`${foodItem.title} image`} />
					</AspectRatioBox>
					<Content>
						<Tags>
							{foodItem.location && (
								<Tag
									icon={
										mainScript.assetPath + "images/svg/icons/location-icon.svg"
									}
									dangerouslySetInnerHTML={{ __html: foodItem.location }}
								/>
							)}
							<Tag
								icon={
									mainScript.assetPath + "images/svg/icons/icon-food-card.svg"
								}
							>
								{foodItem["filter-name"]}
							</Tag>
						</Tags>
						<Title dangerouslySetInnerHTML={{ __html: foodItem.title }} />
					</Content>
				</div>
				{foodItem.vendor && <OfferedBy>{foodItem.vendor}</OfferedBy>}
			</Card>
		</AnimatePresence>
	);
};

export default FeaturedFoodCard;

FeaturedFoodCard.propTypes = {
	toggleSidePanel: PropTypes.func,
	foodItem: PropTypes.object,
	isSidePanelOff: PropTypes.bool,
};

const Card = styled(motion.li)`
	list-style: none;
	margin: 0;
	padding: 0;
	cursor: ${(props) => !props.issidepaneloff == "true" && "pointer"};
	box-shadow: 0px 6.42px 19.26px rgba(0, 0, 0, 0.15);
	border-radius: 16.05px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	${(props) =>
		!props.issidepaneloff == "true" &&
		`&:hover {
			img {
				transition: all 0.5s;
				transform: scale(1.1);
			}
		}`}
`;

const Content = styled.div`
	padding: 0 2.6rem;
`;

const AspectRatioBox = styled.div`
	position: relative;
	width: 100%;
	display: block;
	overflow: hidden;
	padding-top: calc(244 / 300 * 100%);
	border-radius: 16.05px;

	> img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		border-radius: 16.05px;
		transition: all 0.5s;
	}
`;

const Tags = styled.div`
	padding-top: 2rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

const Tag = styled.span`
	font-weight: 700;
	font-size: 1rem;
	line-height: 1.1rem;
	text-transform: uppercase;
	display: flex;
	gap: 0.47rem;
	align-items: center;

	&::before {
		content: "";
		background-image: url(${(props) => props.icon});
		background-size: 100%;
		background-repeat: no-repeat;
		display: inline-block;
		width: 16px;
		height: 18px;
	}
`;

const Title = styled.h3`
	padding-top: 2rem;
	font-size: 1.8rem;
	line-height: 2.1rem;
`;

const OfferedBy = styled.p`
	padding: 1.2rem 2.6rem 2.3rem;
	font-weight: ${Typography.fontWeight.bold};
	font-size: 1rem;
	line-height: 1.1rem;
	text-transform: uppercase;
`;
